document.addEventListener('teeinblue-event-component-injected', function() {
  window.upcartShouldAddToCartContinue = (e) => !document.querySelector('#tee-add').contains(e.target); 
})

document.addEventListener('teeinblue-event-component-injected', function() {
  const id = document.querySelector(teeinblue?.formSelector ?? 'form[action*="cart/add"]')?.elements?.id?.value;

  if (id) {
    const url = new URL(window.location.href);

    if (url && url.searchParams && !url.searchParams.has('variant')) {
      url.searchParams.append('variant', id);
      const newUrl = url.toString();
      window.location.replace(newUrl);
    }
  }
})